// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"cd52b026","977":"5a1b2dc6"}[chunkId] + ".chunk.js";
};